export function searchByVehicleInfo(text: string, vehicle: any) {
  const search = text.toLowerCase()
  const fields = ['model', 'color', 'vin', 'registrationNumber']

  return fields.some(key => vehicle[key]?.toLowerCase().includes(search))
}
